import { Routes } from '@angular/router';
import { AuthGuard } from '../auth/auth.guard';

export const reportsRoutes: Routes = [
  {
    path: 'mva-gfap-analysis',
    loadComponent: () =>
      import('./mva-gfap-analysis/mva-gfap-analysis.component').then(
        (m) => m.MVAGFAPAnalysisComponent
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'cnesst-frequency',
    loadComponent: () =>
      import('./cnesst-frequency/cnesst-frequency.component').then(
        (m) => m.CNESSTFrequencyComponent
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'business-analysis',
    loadComponent: () =>
      import('./business-analysis/business-analysis.component').then(
        (m) => m.BusinessAnalysisComponent
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'dynamic-reports/:gridId',
    loadComponent: () =>
      import('./dynamic-reports/dynamic-reports.component').then(
        (m) => m.DynamicReportsComponent
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'drop-off-reports',
    loadComponent: () =>
      import('./drop-offs/summary-grid/summary-grid.component').then(
        (m) => m.SummaryGridComponent
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'analytics-kpi/:gridId',
    loadComponent: () =>
      import('../analytics/analytics-kpi/analytics-kpi.component').then(
        (m) => m.AnalyticsKpiComponent
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'quality-of-care-kpi/:gridId',
    loadComponent: () =>
      import(
        '../analytics/quality-of-care-kpi/quality-of-care-kpi.component'
      ).then((m) => m.QualityOfCareKpiComponent),
    canActivate: [AuthGuard],
  },
];
